import { ref, toRefs } from 'vue';
import { useRequestApi, useRequestWithSnackBar } from '@/composition/fetch';
import { MemberForm } from '@/api/company/companyMemberApi';
export const useMemberForm = (api) => {
    const form = ref(new MemberForm());
    const { request, state } = useRequestApi(api, 0);
    const { loading } = toRefs(state);
    const rules = {
        company: [(v) => !!v || 'Company is Required'],
        userId: [
            (v) => !!v || 'ID is Required',
            (v) => /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*/.test(v) || 'input only start lower or number',
            (v) => (v && v.length > 3) || 'Length is more then 3',
            (v) => (v && v.length < 50) || 'Length is less then 50'
        ],
        userRole: [(v) => !!v || 'User Role is Required']
    };
    return {
        form,
        setForm(newForm) {
            form.value = { valid: false, ...newForm };
        },
        rules,
        loading,
        save: () => useRequestWithSnackBar(request)(form.value)
    };
};
